import { render } from "./index.vue?vue&type=template&id=31a8fe3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=31a8fe3e&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a8fe3e"]])

export default __exports__